import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { WarningIcon } from '@phosphor-icons/react';
import { PageContent } from '@/components/page-content';
import { SectionHeader } from '@/components/section-header';
import { Button } from '@/components/ui/button';
import { useProjects } from '@/hooks/use-projects';
import { ProjectsService } from '@/api';

export const Route = createFileRoute(
  '/_auth/_side-layout/project-settings/danger-zone',
)({
  component: DangerZoneSettings,
});

function DangerZoneSettings() {
  const navigate = useNavigate();
  const { projectId, project } = useProjects();

  return (
    <PageContent>
      <div className="border-destructive bg-destructive/10 w-full space-y-6 rounded border p-6">
        <SectionHeader
          icon={<WarningIcon size={20} />}
          className="text-destructive"
          subTitle="By deleting your project, you are deleting all events linked to that project."
          title="Danger"
        />
        <Button
          variant="destructive"
          onClick={async () => {
            const shouldDelete = window.confirm(
              `I want to delete ${project?.name} project. Press OK to delete.`,
            );

            if (shouldDelete && projectId) {
              await ProjectsService.deleteProject({ projectId });
              navigate({ to: '/home' as string });
            }
          }}
        >
          Delete Project
        </Button>
      </div>
    </PageContent>
  );
}
